import { Injectable } from '@angular/core';
import { map, mergeMap } from 'rxjs/operators';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import {
  FollowUpActionToggleLoading,
  FollowUpActionTypes,
  FollowUpPageLoaded,
  FollowUpPageRequested,
  FollowUpPageToggleLoading,
} from '../_actions/follow-up.actions';
import { Router } from '@angular/router';
import { FollowUpService } from '../../services/follow-up.service';

@Injectable()
export class FollowUpEffects {
  showPageLoadingDistpatcher = new FollowUpPageToggleLoading({ isLoading: true });
  hidePageLoadingDistpatcher = new FollowUpPageToggleLoading({ isLoading: false });
  showActionLoadingDistpatcher = new FollowUpActionToggleLoading({ isLoading: true });
  hideActionLoadingDistpatcher = new FollowUpActionToggleLoading({ isLoading: false });

  @Effect()
  loadFollowUpPage$ = this.actions$.pipe(
    ofType<FollowUpPageRequested>(FollowUpActionTypes.FollowUpPageRequested),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showPageLoadingDistpatcher);
      return this.followUpService.getFollowUpPaginatedByFilters(payload.page);
    }),
    map((result) => {
      return new FollowUpPageLoaded({
        followUp: result.data,
        totalCount: result.count,
        page: result.page,
      });
    }),
  );

  constructor(
    private actions$: Actions,
    private followUpService: FollowUpService,
    private store: Store<AppState>,
    private router: Router,
  ) {}
}
